export const parseAdditionalDetails = (additionalDetails: Record<string, any>) => {
  const parseToDataSetObject = (obj: Record<string, string>) =>
    Object.keys(obj).map((k) => ({
      label: k,
      value: obj[k],
    }));

  const {
    chemicalCompositionTestResults,
    physicalPropertiesTestResults,
    particleSizeDistributionTestResults,
    testResults,
    dealer,
  } = additionalDetails;

  if (chemicalCompositionTestResults) {
    additionalDetails.chemicalCompositionTestResults = parseToDataSetObject(
      chemicalCompositionTestResults
    );
  }

  if (physicalPropertiesTestResults) {
    additionalDetails.physicalPropertiesTestResults = parseToDataSetObject(
      physicalPropertiesTestResults
    );
  }

  if (particleSizeDistributionTestResults) {
    additionalDetails.particleSizeDistributionTestResults = parseToDataSetObject(
      particleSizeDistributionTestResults
    );
  }

  if (testResults) {
    additionalDetails.testResults = parseToDataSetObject(testResults);
  }

  if (dealer) {
    additionalDetails.dealer = parseToDataSetObject(dealer);
  }

  return additionalDetails;
};
